import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const TimeAgo = (props) => {
  const {
    date, live, editionInfo, useLongFormat, hoursLimit,
  } = props;
  const locale = editionInfo.locale.slice(0, 2).toLowerCase();
  const [recentClass, setRecentClass] = useState('not-recent');
  const [isLive, setIsLive] = useState(live);

  const secondsToDateLabel = (d, timeAgoLocale) => {
    const dateToTimeAgo = new Date(d);
    const milliseconds = dateToTimeAgo.getTime();
    const now = new Date().getTime();
    const diff = now - milliseconds;

    const msPerMinute = 60 * 1000;
    const msPerHour = msPerMinute * 60;
    const msPerXHours = msPerHour * hoursLimit;

    const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const m = Math.floor((diff / (1000 * 60)) % 60);

    let hourLabel = useLongFormat ? 'hour' : 'hr';
    if (h > 1) {
      hourLabel += 's';
    }
    let minLabel = useLongFormat ? 'minute' : 'min';
    if (m > 1) {
      minLabel += 's';
    }

    const hDisplay = h > 0 ? `${h} ${hourLabel}` : '';
    const mDisplay = m > 0 ? `${m} ${minLabel}` : '';

    const agoMsg = 'ago'; // TODO: localize

    const rtf = new Intl.RelativeTimeFormat(timeAgoLocale, { numeric: 'auto', style: 'long' });

    if (diff < msPerMinute) {
      if (recentClass === 'not-recent') {
        setRecentClass('recent');
      }
      return 'Just now'; // TODO: localize
    } if (diff < msPerHour) {
      if (recentClass === 'not-recent') {
        setRecentClass('recent');
      }
      return rtf.format(-Math.floor(diff / msPerMinute), 'minutes');
    } if (diff < msPerXHours) {
      if (recentClass === 'recent') {
        setRecentClass('not-recent');
      }
      return `${hDisplay} ${mDisplay} ${agoMsg}`;
    }
    if (isLive) {
      setIsLive(false);
    }
    return d;
  };

  const [relTime, setRelTime] = useState(secondsToDateLabel(date, locale));
  const [intervalID, setIntervalID] = useState();

  useEffect(() => {
    let mounted = true;
    if (isLive) {
      setIntervalID(setInterval(() => {
        if (mounted) {
          setRelTime(secondsToDateLabel(date, locale));
        }
      }, 60000));
    }
    return function cleanup() {
      mounted = false;
      if (intervalID) {
        clearInterval(intervalID);
      }
    };
  }, []);

  const timeAgoClassName = `time-ago time-ago--${recentClass}`;
  return (
    <div className={timeAgoClassName}>
      <time dateTime={date} aria-label={`Updated on ${date}`}>{relTime}</time>
    </div>
  );
};

TimeAgo.propTypes = {
  date: PropTypes.string.isRequired,
  live: PropTypes.bool,
  editionInfo: PropTypes.shape({}),
  useLongFormat: PropTypes.bool,
  hoursLimit: PropTypes.number,
};
TimeAgo.defaultProps = {
  live: true,
  editionInfo: {
    locale: 'en',
  },
  useLongFormat: false,
  hoursLimit: 12,
};

export default TimeAgo;
